import { render, staticRenderFns } from "./select2Part.vue?vue&type=template&id=5c2d476c&"
import script from "./select2Part.vue?vue&type=script&lang=js&"
export * from "./select2Part.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports